(function ($) {
  $('.block--hero').each(function () {
    var that = $(this);
    var carousel = that.find(".swiper-container");

    var names = [];
    that.find(".swiper-container .swiper-slide").each(function () {
      names.push($(this).data("name"));
    });

    var swiper = new Swiper(carousel[0], {
      autoHeight: true,
      effect: 'fade',
      allowTouchMove: false,
      pagination: {
        el: that.find('.slider-tabs')[0],
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + names[index] + '</span>';
        }
      },
      fadeEffect: {
        crossFade: true
      },
      hashNavigation: {
        watchState: true,
      },
    });

    that.find(".swiper-pagination-bullet").each(function () {
      var text = $(this).text();
      var parts = text.split(' ');
      var number = parts.slice(0,1);
      var model = parts.slice(1).join(' ');
      if(!isNaN(number)) {
        var number = "<strong>" + number + "</strong>"
      }
      $(this).html(number + " " + model);
    });
  });
})(jQuery);
